<template>
  <main class="das-form-container">
    <section class="das-form-group">
      <div class="das-form-group-title">Thông tin khác</div>
      <!-- Code Thông tin phương tiện mới -->
      <div class="das-form-row">
        <div
          class="grid-scroll mt-10"
          style="height: calc(40px + 5 * 34px); width: 100%; overflow: visible"
        >
          <GridVx
            ref="vehicleGrid"
            class="agGrid"
            :columns="vehicleCols"
            :rows="vehicles"
            :context="context"
            :auto-select-first-row="false"
            :auto-size-cell="true"
            dom-layout="scroll"
            style="overflow: visible"
          />
        </div>
      </div>
      <!-- Thông tin phương tiện cũ -->
      <!-- <div class="grid grid-col-4">
        <div class="das-form-input">
          <div class="label required">Phương tiện</div>
          <div>
            <validation-provider
              :name="$t('field.phoneNumber')"
              rules="required"
            >
              <input v-model="bookingFormData.vehicle" type="text" />
            </validation-provider>
          </div>
        </div>
        <div class="das-form-input">
          <div class="label required">Biển số xe</div>
          <div>
            <validation-provider
              :name="$t('field.phoneNumber')"
              rules="required"
            >
              <input v-model="bookingFormData.license_plate" type="text" />
            </validation-provider>
          </div>
        </div>
        <div class="das-form-input">
          <div class="label required">Thời gian đến</div>
          <div>
            <validation-provider
              :name="$t('field.phoneNumber')"
              rules="required"
            >
              <input v-model="bookingFormData.arrival_time" type="text" />
            </validation-provider>
          </div>
        </div>
        <div class="das-form-input">
          <div class="label required">Thời gian đi</div>
          <div>
            <validation-provider
              :name="$t('field.phoneNumber')"
              rules="required"
            >
              <input v-model="bookingFormData.depart_time" type="text" />
            </validation-provider>
          </div>
        </div>
      </div> -->
      <!-- end Thông tin phương tiện cũ -->
    </section>
    <hr />
    <section class="das-form-group">
      <div>
        <div class="das-form-group-title">
          <div class="justify-space-between">
            <div>
              <label for="e_invoice">Lấy hoá đơn điện tử</label>
              <div class="checkbox-wrap ml-10">
                <input
                  id="e_invoice"
                  v-model="formData.e_invoice"
                  type="checkbox"
                />
                <label for="e_invoice"> </label>
              </div>
            </div>
            <div>
              <button
                class="btn small primary outline"
                @click="onGetAgencyInfo"
              >
                Lấy thông tin công ty du lịch
              </button>
              <button
                class="btn small primary outline ml-10"
                @click="addInvoiceCompany"
              >
                Lưu hồ sơ công ty xuất hóa đơn
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="grid grid-col-3">
        <div class="das-form-input">
          <div class="label required">Tên công ty trên hóa đơn</div>
          <div>
            <validation-provider
              :name="$t('field.phoneNumber')"
              rules="required"
            >
              <input v-model="formData.invoice_agent_name" type="text" />
            </validation-provider>
          </div>
        </div>
        <div class="das-form-input">
          <div class="label required">Địa chỉ</div>
          <div>
            <validation-provider
              :name="$t('field.phoneNumber')"
              rules="required"
            >
              <input v-model="formData.invoice_address" type="text" />
            </validation-provider>
          </div>
        </div>

        <div class="das-form-input">
          <div class="label required">Mã số thuế</div>
          <div>
            <validation-provider
              :name="$t('field.phoneNumber')"
              rules="required"
            >
              <input v-model="formData.invoice_tax" type="text" />
            </validation-provider>
          </div>
        </div>
        <div class="das-form-input">
          <div class="label required">Số điện thoại</div>
          <div>
            <validation-provider
              :name="$t('field.phoneNumber')"
              rules="required"
            >
              <input
                v-model="formData.invoice_phone"
                v-numeric-only
                type="text"
              />
            </validation-provider>
          </div>
        </div>
        <div class="das-form-input">
          <div class="label required">Email</div>
          <div>
            <validation-provider
              :name="$t('field.phoneNumber')"
              rules="required"
            >
              <input v-model="formData.invoice_email" type="text" />
            </validation-provider>
          </div>
        </div>
        <div class="das-form-input">
          <div class="label required">Yêu cầu đặc biệt</div>
          <div>
            <validation-provider
              :name="$t('field.phoneNumber')"
              rules="required"
            >
              <textarea v-model="formData.special_command" />
            </validation-provider>
          </div>
        </div>
      </div>
    </section>
    <hr />
    <section class="das-form-group">
      <div class="das-form-group-title">Đại lý du lịch</div>
      <el-row :gutter="16">
        <el-col :span="8" class="das-form-input">
          <div class="label">Công ty đại lý du lịch 1</div>
          {{ agent?.name }}
        </el-col>
        <!-- <el-col :span="8" class="das-form-input">
          <div class="label">Công ty đại lý du lịch 2</div>
          <validation-provider
            :name="$t('field.amountOfNight')"
            rules="required|number|min_value:0"
          >
            <el-select
              v-model="formData.agent_id_2"
              placeholder="Vui lòng chọn"
            >
              <el-option
                v-for="item in agencyOption"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </validation-provider>
        </el-col> -->
        <el-col :span="8" class="das-form-input">
          <div class="commission-attributes">
            <el-row :gutter="8">
              <el-col :span="12">
                <div class="label">Hoa hồng (Tiền)</div>
                <validation-provider
                  :name="$t('field.amountOfNight')"
                  rules="required|number|min_value:0"
                >
                  <input
                    v-model="formData.commission_fee"
                    type="number"
                    @blur="formData.commission_percent = null"
                  />
                </validation-provider>
              </el-col>
              <el-col :span="12">
                <div class="label">Hoa hồng (%)</div>
                <validation-provider
                  :name="$t('field.amountOfNight')"
                  rules="required|number|min_value:0"
                >
                  <input
                    v-model="formData.commission_percent"
                    type="number"
                    @blur="formData.commission_fee = null"
                  />
                </validation-provider>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </section>
  </main>
</template>
<script>
/* eslint-disable */
import {
  getAgentByIdApi,
  getAgentSimpleListApi
} from '@/api/configuration/profile/agent'
import { addInvoiceCompanyApi } from '@/api/configuration/profile/invoiceCompany'
import { notifyError, notifySuccess } from '@/utils/toast'
import { validEmail } from '@/utils/validate'
import {
  CellRenderDeleteIcon,
  CellRenderTextInput,
  CellRenderDateTimeInput,
  CellHeaderAddIcon
} from '@/utils/cellRenders.js'

import MultiGridsTransfer from '@/components/grid/MultiGridsTransfer.vue'

export default {
  components: {
    CellRenderTextInput,
    CellRenderDeleteIcon,
    CellHeaderAddIcon,
    MultiGridsTransfer,
    CellRenderDateTimeInput
  },
  props: {
    agentId: null,
    bookingData: {
      default: () => {
        return []
      }
    },
    additionalInfoData: {
      default: () => {
        return {
          commission_fee: null,
          commission_percent: null,
          invoice_address: null,
          invoice_agent_name: null,
          invoice_name: null,
          invoice_tax: null,
          invoice_phone: '',
          invoice_email: null,
          special_command: null,
          e_invoice: false
        }
      }
    }
  },
  data() {
    return {
      commission_type: 1,
      commission_value: null,
      tableColumns: [
        {
          headerName: 'Chọn',
          field: 'guest_status'
        },
        {
          headerName: 'Số hợp đồng',
          field: 'is_main_guest'
        },
        {
          headerName: 'Từ ngày',
          field: 'last_name'
        },
        {
          headerName: 'Đến ngày',
          field: 'arrival_date'
        },
        {
          headerName: 'Origin',
          field: 'departureDate'
        },
        {
          headerName: 'Pickup',
          field: 'phone'
        },
        {
          headerName: 'Phòng trống',
          field: 'email'
        },
        {
          headerName: 'Hạng phòng',
          field: 'address_line_1'
        }
      ],
      tableData: [],
      vehicles: [],
      // vehicle
      bookingFormData: [
        // {
        //   vehicle: null,
        //   depart_time: null,
        //   arrival_time: null,
        //   license_plate: null
        // },
      ],
      formData: {
        commission_fee: null,
        commission_percent: null,
        invoice_address: null,
        invoice_name: null,
        invoice_agent_name: null,
        invoice_tax: null,
        invoice_phone: '',
        invoice_email: null,
        special_command: null,
        e_invoice: false
      },

      agencyOption: [],
      context: null
    }
  },
  computed: {
    agent() {
      return this.agencyOption.find(agency => agency.id === this.agentId)
    },
    vehicleCols() {
      return [
        {
          headerName: 'Tên phương tiện',
          field: 'vehicle_name',
          flex: 2,
          minWidth: 100
        },
        {
          headerName: 'Biển kiểm soát',
          field: 'license_plate',
          flex: 2,
          // cellClass: 'grid-cell-centered',
          minWidth: 100,
          cellRenderer: 'CellRenderTextInput',
          cellRendererParams: () => {
            return {
              type: 'text',
              colName: 'license_plate'
            }
          }
        },
        {
          headerName: 'Thời gian đến',
          field: 'arrive_time',
          flex: 2,
          // cellClass: 'grid-cell-centered',
          minWidth: 100,
          cellRenderer: 'CellRenderDateTimeInput',
          cellRendererParams: data => {
            return {
              type: 'text',
              colName: 'arrive_time',
              clearable: true,
              dateType: 'datetime',
              format: 'dd/MM/yyyy HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss'
            }
          }
        },
        {
          headerName: 'Thời gian đi',
          field: 'depart_time',
          flex: 2,
          // cellClass: 'grid-cell-centered',
          minWidth: 100,
          cellRenderer: 'CellRenderDateTimeInput',
          cellRendererParams: data => {
            return {
              type: 'text',
              colName: 'depart_time',
              clearable: true,
              dateType: 'datetime',
              format: 'dd/MM/yyyy HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss'
            }
          }
        },
        {
          headerName: '',
          width: 50,
          cellRenderer: 'CellRenderDeleteIcon',
          headerComponent: 'CellHeaderAddIcon',
          cellStyle: () => {
            return {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }
          }
        }
      ]
    }
  },
  created() {
    Object.assign(this.formData, this.additionalInfoData)
    // this.bookingFormData.vehicle = this.bookingData.vehicle
    // this.bookingFormData.depart_time = this.bookingData.depart_time
    // this.bookingFormData.arrival_time = this.bookingData.arrival_time
    // this.bookingFormData.license_plate = this.bookingData.license_plate
  },
  async mounted() {
    Promise.all([this.getAgencies()])
  },
  methods: {
    hydrateForm() {},
    validateVehicleFormData() {
      for (let i = 0; i < this.vehicles.length; i++) {
        if (
          this.vehicles[i].vehicle_name == null ||
          this.vehicles[i].vehicle_name == '' ||
          this.vehicles[i].license_plate == null ||
          this.vehicles[i].license_plate == '' ||
          this.vehicles[i].arrive_time == null ||
          this.vehicles[i].arrive_time == '' ||
          this.vehicles[i].depart_time == null ||
          this.vehicles[i].depart_time == ''
        ) {
          if (
            this.vehicles[i].vehicle_name == null ||
            this.vehicles[i].vehicle_name == ''
          ) {
            return this.$t('validation.required', {
              field: 'tên phương tiện'
            })
          }
          if (
            this.vehicles[i].license_plate == null ||
            this.vehicles[i].license_plate == ''
          ) {
            return this.$t('validation.required', {
              field: 'biển kiểm soát'
            })
          }
          if (
            this.vehicles[i].arrive_time == null ||
            this.vehicles[i].arrive_time == ''
          ) {
            return this.$t('validation.required', {
              field: 'thời gian đến của xe'
            })
          }
          if (
            this.vehicles[i].depart_time == null ||
            this.vehicles[i].depart_time == ''
          ) {
            return this.$t('validation.required', {
              field: 'thời gian đi của xe'
            })
          }
        }
      }
      return null
    },
    dehydrateBookingFrom() {
      return {
        vehicles: this.vehicles.map(vehicle => ({
          ...JSON.parse(JSON.stringify(vehicle)),
          vehicle_name: 'Ô tô'
        }))
      }
    },
    dehydrateForm() {
      const payload = JSON.parse(JSON.stringify(this.formData))
      return payload
    },
    changeDateTime(params, value, colName) {
      const idx = params.rowIndex
      this.vehicles[idx][colName] = value
    },
    async addInvoiceCompany() {
      const isValidInvoiceCompanyData =
        this.formData.invoice_tax != null &&
        this.formData.invoice_agent_name &&
        this.formData.invoice_address
      if (!isValidInvoiceCompanyData) {
        notifyError('invoiceInfoMissing')
        return
      }

      if (this.formData.invoice_email) {
        const error = validEmail(this.formData.invoice_email)
        if (!error) {
          notifyError(this.$t('validation.email'), true)
          return
        }
      }
      await addInvoiceCompanyApi({
        code: this.formData.invoice_tax,
        email: this.formData.invoice_email,
        name: this.formData.invoice_agent_name,
        address: this.formData.invoice_address,
        note: this.formData.note,
        phone_number: this.formData.invoice_phone,
        bank_name: null,
        bank_account_number: null
      })
        .then(response => {
          notifySuccess(response?.message)
        })
        .catch(err => {
          notifyError(err?.response?.data?.message)
        })
    },
    async getAgencies() {
      await getAgentSimpleListApi().then(response => {
        this.agencyOption = response.data
      })
    },
    async onGetAgencyInfo() {
      if (this.agentId == null) {
        notifyError('agencyNotSelected')
        return
      }
      await getAgentByIdApi({
        id: this.agentId
      }).then(response => {
        const agency = response.data
        this.formData.invoice_agent_name = agency.invoice_agent_name
        this.formData.invoice_address = agency.address_1
        this.formData.invoice_tax = agency.tax_code
        this.formData.invoice_phone = agency.phone_1
        this.formData.invoice_email = agency.email
        notifySuccess()
      })
    },
    onAddRowInGrid() {
      this.vehicles.unshift({
        vehicle_name: 'Ô tô',
        license_plate: null,
        arrive_time: null,
        depart_time: null
      })
      console.log(this.vehicles)
    },
    onDeleteIconClicked(data) {
      const idx = data.rowIndex
      this.vehicles.splice(idx, 1)
    },
    textInputChange(params, data, colName) {
      this.vehicles[params.node.rowIndex][colName] = data
    }
  },

  beforeMount() {
    this.context = { componentParent: this }
    this.vehicles = (this.bookingData ?? []).map(vehicle => ({
      ...JSON.parse(JSON.stringify(vehicle)),
      vehicle_name: 'Ô tô'
    }))
  },

  onMounted: () => {
    this.tableData = []
  }
}
</script>
<style scoped>
.das-form-container textarea {
  width: 100%;
}

.grid {
  display: grid;
  width: 100%;
  gap: 16px;
}

.grid-col-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.grid-col-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.col-span-2 {
  grid-column: span 2 / span 2;
}

.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
</style>
